import React, { useState } from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import Error from './Error';


const Formulario = ({guardarGasto, guardarCrearGasto, restante}) => {

  const [nombre, guardarNombre] = useState('');
  const [cantidad, guardarCantidad] = useState(0);
  const [error, guardarError] = useState(false);
  const [validacion, setValidacion] = useState(false)
  
  

  //cuando el usuario agrega un gasto
  const agregarGasto = e => {
    e.preventDefault();

    //validar 
      if(cantidad < 1 || isNaN(cantidad) || nombre.trim() === ''){
        guardarError(true);
        return;
      }else if(cantidad > restante){
        setValidacion(true);
        return;
    }
      guardarError(false);
      setValidacion(false);

    //construir el gasto
    const gasto = {
      nombre,
      cantidad,
      id:shortid.generate()
    }

    //pasar el gasto al componente principal
    guardarGasto(gasto);
    guardarCrearGasto(true);

    //resetear el form
    guardarNombre('');
    guardarCantidad(0);
    
  }

    return ( 
        <form
         onSubmit={agregarGasto}
        >
            <h3 className="text-primary text-center py-2">Agrega tus gastos</h3>

            { error ? <Error mensaje="Ambos campos son oblogatorios o Presupuesto Incorrecto."/> : null }
            { validacion ? <Error mensaje="Presupuesto Insuficiente."/> : null }

            <div className="entrada mb-2">
                <label>Nombre Gasto</label>
            <input
              type="text"
              className="form-control"
              placeholder="Ej. Luz"
              value={nombre}
              onChange={e => guardarNombre(e.target.value)}
            />
            </div>

            <div className="entrada mb-3">
                <label>Cantidad Gasto</label>
            <input
              type="number"
              className="form-control"
              placeholder="Ej. 300"
              value={cantidad}
              onChange={e => guardarCantidad(parseInt(e.target.value, 10))}
            />
            </div>

            <input
            type="submit"
            className="btn btn-primary btn-block mb-5"
            value="Agregar Gasto"
            />

        </form>
     );
}
Formulario.propTypes = {
  guardarGasto: PropTypes.func.isRequired,
  guardarCrearGasto: PropTypes.func.isRequired
}
 
export default Formulario;